import {httpGet, httpPost} from './http.service';
import {IPaginatedResult} from '../incase-domain/search';
import {ICodebookEntry} from '../incase-domain/codebook';

export const fetchCodebookEntries = (
    id: string,
    page: number,
    size: number,
    searchString?: string
): Promise<IPaginatedResult<ICodebookEntry>> => {
    return httpGet(`editor/codebook/${id}/entries?page=${page}&size=${size}${searchString ? `&searchString=${searchString}` : ''}`);
};

export const fetchCodebookEntriesByIds = (ids: string[]): Promise<ICodebookEntry[]> => {
    return httpPost(`editor/codebook/entries`, {ids});
};
